// AUTO-GENERATED FILE. DO NOT EDIT.

import {
    Pretend,
    IPretendRequest,
    Put,
    Post,
    Get,
    Headers as PretendHeaders
} from 'pretend';

import * as dtos from './dtos';
import { parseApiDates } from '@spa-frontend/date-lib';

export const PARSE_RESULT_METADATA_KEY = Symbol('parseResultMetadata');
export const parseResult = (props: string[]) => {
    return (
        _target: Object,
        _key: string | symbol,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        descriptor: TypedPropertyDescriptor<any>
    ) => {
        const fn = descriptor.value;

        descriptor.value = async function (...args: unknown[]) {
            const result = await fn.apply(this, args);

            const tupleProps = props.map((prop) => prop.split('.'));

            return parseApiDates(result, tupleProps);
        };

        Reflect.defineMetadata(PARSE_RESULT_METADATA_KEY, props, _target, _key);

        return descriptor;
    };
};

export interface AuthenticatePayment {
    authenticatePayment(
        paymentRequestToken: string,
        dto: dtos.AuthenticatePaymentV1Dto
    ): Promise<dtos.PaymentV1Dto>;
}

export interface CreatePayment {
    createPayment(
        paymentRequestToken: string,
        dto: dtos.CreatePaymentV1Dto
    ): Promise<dtos.PaymentV1Dto>;
}

export interface CreatePaymentRequest {
    createPaymentRequest(): Promise<
        dtos.PaymentRequestV1Dto | dtos.PaymentRequestV1Dto
    >;
}

export interface ExecutePayment {
    executePayment(
        paymentRequestToken: string,
        dto: dtos.ExecutePaymentV1Dto
    ): Promise<dtos.PaymentV1Dto>;
}

export interface GetAvailablePaymentMethods {
    getAvailablePaymentMethods(): Promise<dtos.AvailablePaymentMethodsV1Dto[]>;
}

export interface GetPayment {
    getPayment(paymentRequestToken: string): Promise<dtos.PaymentV1Dto>;
}

export interface GetUserAccountPaymentInstruments {
    getUserAccountPaymentInstruments(): Promise<dtos.UserAccountPaymentInstrumentsV1Dto>;
}

export interface GetUserPaymentSessionDetails {
    getUserPaymentSessionDetails(): Promise<dtos.UserPaymentSessionDetailsResponseDto>;
}

export interface ValidateIban {
    validateIban(
        dto: dtos.IbanValidationRequestV1Dto
    ): Promise<dtos.IbanValidationResponseV1Dto>;
}

export interface Payments {
    AuthenticatePayment: AuthenticatePayment;
    CreatePayment: CreatePayment;
    CreatePaymentRequest: CreatePaymentRequest;
    ExecutePayment: ExecutePayment;
    GetAvailablePaymentMethods: GetAvailablePaymentMethods;
    GetPayment: GetPayment;
    GetUserAccountPaymentInstruments: GetUserAccountPaymentInstruments;
    GetUserPaymentSessionDetails: GetUserPaymentSessionDetails;
    ValidateIban: ValidateIban;
}

/* eslint-disable @typescript-eslint/no-explicit-any */

class AuthenticatePaymentBlueprint implements AuthenticatePayment {
    @PretendHeaders('Content-Type: application/json')
    @Put('/api/v1/payments/{paymentRequestToken}/authenticate')
    public authenticatePayment(_p0: any, _p1: any): any {
        /**/
    }
}

class CreatePaymentBlueprint implements CreatePayment {
    @PretendHeaders('Content-Type: application/json')
    @Post('/api/v1/payments/{paymentRequestToken}')
    public createPayment(_p0: any, _p1: any): any {
        /**/
    }
}

class CreatePaymentRequestBlueprint implements CreatePaymentRequest {
    @parseResult(['tokenValidUntil'])
    @Post('/api/v1/payment-requests')
    public createPaymentRequest(): any {
        /**/
    }
}

class ExecutePaymentBlueprint implements ExecutePayment {
    @PretendHeaders('Content-Type: application/json')
    @Put('/api/v1/payments/{paymentRequestToken}/execute')
    public executePayment(_p0: any, _p1: any): any {
        /**/
    }
}

class GetAvailablePaymentMethodsBlueprint
    implements GetAvailablePaymentMethods
{
    @Get('/api/v1/user-payment-sessions/available-payment-methods')
    public getAvailablePaymentMethods(): any {
        /**/
    }
}

class GetPaymentBlueprint implements GetPayment {
    @Get('/api/v1/payments/{paymentRequestToken}')
    public getPayment(_p0: any): any {
        /**/
    }
}

class GetUserAccountPaymentInstrumentsBlueprint
    implements GetUserAccountPaymentInstruments
{
    @parseResult(['paymentInstruments.createdDate'])
    @Get('/api/v1/user-payment-sessions/payment-instruments')
    public getUserAccountPaymentInstruments(): any {
        /**/
    }
}

class GetUserPaymentSessionDetailsBlueprint
    implements GetUserPaymentSessionDetails
{
    @parseResult(['tokenValidUntil'])
    @Get('/api/v1/user-payment-sessions')
    public getUserPaymentSessionDetails(): any {
        /**/
    }
}

class ValidateIbanBlueprint implements ValidateIban {
    @PretendHeaders('Content-Type: application/json')
    @Post('/api/v1/iban/validate')
    public validateIban(_p0: any): any {
        /**/
    }
}

/* eslint-enable @typescript-eslint/no-explicit-any */

export function getClient(
    endpoint: string,
    token: string | undefined,
    configure: (client: Pretend) => Pretend = (client) => client
): Payments {
    const bearerToken = (request: IPretendRequest) => {
        if (token) {
            request.options.headers = new Headers(request.options.headers);
            request.options.headers.set('Authorization', `bearer ${token}`);
        }
        return request;
    };

    return {
        AuthenticatePayment: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(AuthenticatePaymentBlueprint, endpoint),
        CreatePayment: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(CreatePaymentBlueprint, endpoint),
        CreatePaymentRequest: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(CreatePaymentRequestBlueprint, endpoint),
        ExecutePayment: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(ExecutePaymentBlueprint, endpoint),
        GetAvailablePaymentMethods: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(GetAvailablePaymentMethodsBlueprint, endpoint),
        GetPayment: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(GetPaymentBlueprint, endpoint),
        GetUserAccountPaymentInstruments: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(GetUserAccountPaymentInstrumentsBlueprint, endpoint),
        GetUserPaymentSessionDetails: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(GetUserPaymentSessionDetailsBlueprint, endpoint),
        ValidateIban: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(ValidateIbanBlueprint, endpoint)
    };
}
